import { Routes, Route } from "react-router-dom";
import Resume from "./components/pages/resume";
import Main from "./Main";

function App() {
  return (
    <Routes>
        <Route index element={<Main />} />
        <Route path="resume" element={<Resume />} />
    </Routes>
  );
}

export default App;
